"use strict";

exports.__esModule = true;
exports.TabWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _TabElement = require("./TabElement");
var _EditableTabElement = require("./EditableTabElement");
var _TabFields = require("./TabFields");
var _TabHeader = require("./TabHeader");
var _TabWidgetThumbnail = require("./TabWidgetThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TabWidget = exports.TabWidget = {
  name: "Tab",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TabWidget.label",
    defaultMessage: "Tab"
  }),
  getElementLabel: function getElementLabel(element) {
    return element.props.title;
  },
  icon: "tab",
  group: _widgetGroups.LAYOUT_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "Tab",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12,
        id: Math.random().toString(16).slice(2),
        title: "New Tab"
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height", "title"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _TabHeader.TabHeader,
    Element: _TabElement.TabElement,
    Fields: _TabFields.TabFields,
    Editable: _EditableTabElement.EditableTabElement,
    Thumbnail: _TabWidgetThumbnail.TabWidgetThumbnail
  }
};